import { type QueryClient, useQuery } from '@tanstack/react-query';
import type { ParsedInsightsFilters } from '@/common/api/types/dashboard/filters';
import { useOrgId } from '@/common/hooks/useOrgId';
import { insightsQueryKeys } from '@/features/insights/queryKeys';
import { HealthApi } from '@/features/insights-dashboard/api/health';
import { INSIGHTS_STALE_TIME } from '@/features/insights-dashboard/components/data/constants';

export const invalidateHealthSummary = (queryClient: QueryClient) => {
  queryClient.invalidateQueries({ queryKey: insightsQueryKeys.health.all() });
};

export const useHealthSummary = ({
  filters,
  scopeItemId,
  loopId,
  enabled = true,
}: {
  filters: ParsedInsightsFilters;
  scopeItemId?: number;
  loopId: number;
  enabled?: boolean;
}) => {
  const orgId = useOrgId();

  return useQuery({
    queryKey: insightsQueryKeys.health.summary({ filters, scopeItemId, loopId, orgId }),
    queryFn: () => HealthApi.getHealthSummary({ filters, scopeItemId, loopId }),
    enabled,
    staleTime: INSIGHTS_STALE_TIME,
    placeholderData: (previousData) => previousData,
    retry: false,
  });
};
